function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'48d6215903dff56238e52e8891380c8f': 'rgb(37, 59, 153)','4ba2f9c543401a9ab6ba5344598e8325': 'rgb(132, 188, 54)','d487dd0b55dfcacdd920ccbdaeafa351': 'rgb(243, 238, 56)','fe01d67a002dfa0f3ac084298142eccd': 'rgb(230, 123, 48)','bb7aedfa61007447dd6efaf9f37641e3': 'rgb(144, 70, 156)','bda9643ac6601722a28f238714274da4': 'rgb(218, 36, 45)','566d31812e5dde3b7137d1a81f1a080a': 'rgb(0, 137, 84)','4a0b0dcedd48f780778d1cd1bb8f9877': 'rgb(248, 121, 157)','02a01fcf28f6fffceacdb3a699369252': 'rgb(0, 146, 211)','8f4ef05b543fb6157b374099100574b3': 'rgb(239, 239, 239)','6ff47afa5dc7daa42cc705a03fca8a9b': 'rgb(115, 50, 45)','d1d813a48d99f0e102f7d0a1b9068001': 'rgb(182, 10, 116)','153fa52654465ad67f045dc293f3b16e': 'rgb(119, 48, 113)','1ffd9e753c8054cc61456ac7fac1ac89': 'rgb(58, 66, 68)',};

    this.images = {'334c4a4c42fdb79d7ebc3e73b517e6f8': 'url("//www.captivaco.com/cdn/shop/files/none-02_68x.png?v=16717449235486511284")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
